import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import customerPages from "configuration/pageControlConfiguration";
import { PageControlInterface } from "interfaces/pageControl";
import { RootState } from "app/store";

const initialState = customerPages;

export const pageControlSlice = createSlice({
  name: "pageControl",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setNewPage: (state, action: PayloadAction<string>) => {
      const selectedPage = state.pages.find(
        (page) => `/${page.url}` === action.payload,
      );

      if (!selectedPage) {
        return;
      }

      state.pages.forEach((item, i) => {
        if (selectedPage.url === "confirmation") {
          state.pages[i].enabled = selectedPage.sequence <= item.sequence;
        } else {
          state.pages[i].enabled = selectedPage.sequence >= item.sequence;
        }
      });
    },
    setPage: (state, action: PayloadAction<PageControlInterface>) => {
      state.pages[action.payload.sequence] = action.payload;
    },
    setPages: (state, action: PayloadAction<PageControlInterface[]>) => {
      state.pages = action.payload;
    },
    resetPages: (state) => {
      state.pages = initialState.pages;
    },
    setRenderIndex: (state, action: PayloadAction<number>) => {
      state.renderIndex = action.payload;
    },
  },
});

export const { setNewPage, setPages, setPage, resetPages, setRenderIndex } =
  pageControlSlice.actions;

export const selectPages = (state: RootState) => state.pageControl.pages;
export const selectRenderIndex = (state: RootState) =>
  state.pageControl.renderIndex;

//export const selectCurrentPage = (state: RootState) =>

export default pageControlSlice.reducer;
